import { render } from "./GanttChartComponentOriginal.vue?vue&type=template&id=30c910ee&scoped=true"
import script from "./GanttChartComponentOriginal.vue?vue&type=script&lang=js"
export * from "./GanttChartComponentOriginal.vue?vue&type=script&lang=js"

import "./GanttChartComponentOriginal.vue?vue&type=style&index=0&id=30c910ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c910ee"]])

export default __exports__